function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerIconChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 4.5L6 7.5L9 4.5",
    stroke: "#667085",
    style: {
      stroke: "#667085",
      stroke: "color(display-p3 0.4009 0.4408 0.5207)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerIconChevronDown);
export default __webpack_public_path__ + "static/media/tabler-icon-chevron-down.0666901c553f0abc7c7c848cf01aca8d.svg";
export { ForwardRef as ReactComponent };